module.exports = __webpack_public_path__ + "static/media/bg.8626f2c4.png";